module.exports = __webpack_public_path__ + "static/img/bgscimg5back3.d33aacb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/bgscimg5back3.png
// module id = d2TM
// module chunks = 5